import React from 'react';
import {PulseLoader as Loader} from 'react-spinners';

const Loading = () => (
  <div className='spinner-container'>
    <Loader color={'#20a8d8'} className="mx-auto"/>
  </div>
);

export default Loading;


// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js